import React, { useState } from "react";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import { TextField, CircularProgress, InputAdornment } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import PostData from "../../../services/PostData";
import SnackbarEx from "../../Helpers/SnackbarEx.jsx";
import AuthenticatedAssetImage from "../../Helpers/AuthenticatedAssetImage.jsx";
import { catalogSearchFieldSx } from "../../Products/catalogGridStyles.js";
import "../uploadProducts.css";

const fieldColClass = (name) => {
    if (["title", "upc", "size", "color / style"].includes(name)) return "col-6";
    if (["height", "depth", "width", "weight"].includes(name)) return "col-3";
    return "col-12";
};

const fieldLabel = (name) =>
    name.charAt(0).toUpperCase() + name.slice(1).replace(/([A-Z])/g, " $1");

export default function SingleListingShopify({ submitLoad, updateFormData }) {
    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false,
    });
    const [loadRecordSearch, setLoadRecordSearch] = useState(false);
    const [searchSku, setSearchSku] = useState("");

    const formFields = [
        { name: "title", type: "text", initialValue: "", atField: "Listing Field" },
        { name: "upc", type: "text", initialValue: "", atField: "UPC" },
        { name: "brand", type: "text", initialValue: "", atField: "Brand API" },
        { name: "size", type: "text", initialValue: "", atField: "BBsktSize" },
        { name: "color / style", type: "text", initialValue: "", atField: "BBsktColor/Style" },
        { name: "weight", type: "text", initialValue: "", atField: "Weight (lbs)" },
        { name: "height", type: "text", initialValue: "", atField: "Height (in)" },
        { name: "depth", type: "text", initialValue: "", atField: "Depth (in)" },
        { name: "width", type: "text", initialValue: "", atField: "Width (in)" },
        { name: "price", type: "number", initialValue: "", atField: "Suggested Shopify Price" },
        { name: "images", type: "text", initialValue: [], atField: "All Photos" },
        { name: "quantity", type: "number", initialValue: 0, atField: "Available Quantity - Shopify" },
    ];

    const initalState = formFields.reduce(
        (acc, next) => ({ ...acc, [next.name]: next.initialValue }),
        {}
    );
    const [formData, setFormData] = useState([initalState]);

    const submitSearchSku = async (event) => {
        event.preventDefault();
        setLoadRecordSearch(true);
        const { success, data } = await PostData(
            { sku: searchSku.trim() },
            `broylesllc/get-shopify-record`,
            null
        );
        if (success && data && Object.keys(data).length > 0) {
            setLoadRecordSearch(false);
            const updatedFormData = { sku: searchSku.trim() };
            formFields.forEach((field) => {
                if (field.atField && data.fields[field.atField] != null) {
                    let fieldValue = data.fields[field.atField];
                    if (Array.isArray(fieldValue)) {
                        updatedFormData[field.name] = fieldValue[0];
                    } else if (typeof fieldValue === "object" && fieldValue !== null) {
                        updatedFormData[field.name] = Object.values(fieldValue)[0];
                    } else {
                        updatedFormData[field.name] = fieldValue;
                    }
                }
            });
            if (data.fields?.["All Photos"]) {
                updatedFormData.images = data.fields["All Photos"].map((img) => ({
                    id: img.id,
                    url: img.url,
                    filename: img.filename || "",
                    contentType: img.contentType || "",
                    gcsBucket: img.gcsBucket || "",
                    gcsObject: img.gcsObject || "",
                }));
            }
            if (!updatedFormData.price) {
                updatedFormData.price =
                    data.fields?.["Suggested eBay Price"] ||
                    data.fields?.["Suggested Walmart Price"] ||
                    "";
            }
            setFormData((prevFormData) => {
                const next = [...prevFormData];
                if (!next[0]) next.push({});
                next[0] = { ...next[0], ...updatedFormData };
                updateFormData(next);
                return next;
            });
        } else {
            setLoadRecordSearch(false);
            setOpenTestSnack({
                color: "error",
                message: "SKU not found in Products",
                open: true,
            });
        }
    };

    const images = formData[0]?.images || [];

    return (
        <>
            <div className="mb-3">
                <p className="upload-section-label">Search Product SKU</p>
                <form onSubmit={submitSearchSku}>
                    <TextField
                        id="shopify-sku-search"
                        disabled={submitLoad}
                        placeholder="Internal SKU ID"
                        value={searchSku}
                        size="small"
                        onChange={(e) => {
                            setSearchSku(e.target.value);
                            const next = [...formData];
                            if (!next[0]) next[0] = {};
                            next[0] = { ...next[0], sku: e.target.value };
                            setFormData(next);
                            updateFormData(next);
                        }}
                        sx={{ ...catalogSearchFieldSx, width: { xs: "100%", sm: "50%" } }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchOutlinedIcon sx={{ color: "#9aa3ad", fontSize: 18 }} />
                                </InputAdornment>
                            ),
                            endAdornment: loadRecordSearch ? (
                                <InputAdornment position="end">
                                    <CircularProgress size={18} sx={{ color: "#0d9488" }} />
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </form>
            </div>

            <div className="row g-3 m-0">
                <div className="col-12 col-lg-4 p-0 pe-lg-2">
                    <section className="upload-panel h-100">
                        <div className="upload-panel-header">
                            <h3 className="upload-panel-title">Images</h3>
                        </div>
                        <div className="upload-panel-body">
                            <div className="upload-images-row">
                                {images.length ? (
                                    images.map((p) => (
                                        <AuthenticatedAssetImage
                                            key={p.id || p.gcsObject || p.url}
                                            asset={p}
                                            lazy
                                            alt=""
                                            sx={{
                                                width: 72,
                                                height: 72,
                                                borderRadius: "8px",
                                                border: "1px solid #e2e8f0",
                                                backgroundColor: "#f8fafc",
                                            }}
                                        />
                                    ))
                                ) : (
                                    <p className="upload-images-empty">No photos yet</p>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
                <div className="col-12 col-lg-8 p-0 ps-lg-2">
                    <section className="upload-panel">
                        <div className="upload-panel-header">
                            <h3 className="upload-panel-title">Item Overview</h3>
                        </div>
                        <div className="upload-panel-body">
                            <div className="row upload-field-grid m-0">
                                {formFields
                                    .filter((field) => field.name !== "images")
                                    .map((field) => (
                                        <div
                                            key={field.name}
                                            className={fieldColClass(field.name)}
                                        >
                                            <TextField
                                                disabled={submitLoad}
                                                label={fieldLabel(field.name)}
                                                size="small"
                                                value={formData[0]?.[field.name] || ""}
                                                onChange={(e) => {
                                                    const next = [...formData];
                                                    if (!next[0]) next[0] = {};
                                                    next[0] = {
                                                        ...next[0],
                                                        [field.name]: e.target.value,
                                                    };
                                                    setFormData(next);
                                                    updateFormData(next);
                                                }}
                                                InputProps={{
                                                    startAdornment:
                                                        field.name === "price" ? (
                                                            <InputAdornment position="start">
                                                                <AttachMoneyOutlinedIcon
                                                                    sx={{
                                                                        color: "#9aa3ad",
                                                                        fontSize: 18,
                                                                    }}
                                                                />
                                                            </InputAdornment>
                                                        ) : null,
                                                }}
                                                sx={{
                                                    ...catalogSearchFieldSx,
                                                    width: "100%",
                                                }}
                                            />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            {openTestSnack.open && (
                <SnackbarEx
                    color={openTestSnack.color}
                    message={openTestSnack.message}
                    open={openTestSnack.open}
                    close={() =>
                        setOpenTestSnack({ color: "", message: "", open: false })
                    }
                />
            )}
        </>
    );
}
